require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./project-cottesloe-residence.json") })
        }
      }, "path---project-cottesloe-residence");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---project-cottesloe-residence!./.cache/json/project-cottesloe-residence.json
// module id = 566
// module chunks = 231608221292675